import { useSupportRequestCounts } from '@/app/hooks/useSupportRequestCounts'

import { SupportListTab } from '../SupportRequestQueue/useSupportQueue'

/**
 * Os badges das abas saem do `stats/counts`, uma requisição só: nenhuma lista
 * é carregada antes de a pessoa clicar na aba.
 */
export function useSupportListCounts(): Record<SupportListTab, number> {
  const { mine, inProgress, all, team } = useSupportRequestCounts()

  return { mine, inProgress, all, team, stats: 0 }
}
